// extracted by mini-css-extract-plugin
export default {"logo":"event-organizer-box_logo__+FMDa","logoWrapper":"event-organizer-box_logoWrapper__zgXCt"};